import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import * as g from '../../../globals';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less']
})
export class HomeComponent implements OnInit {
  dashboardId = 0;
  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    g.appUrlPrefix('');
    this.activatedRoute.params.subscribe((d) => {
      this.dashboardId = d.dashboardId;
    });
  }
}
